import React from 'react';
import './Hero.css';
import HomeNav from '../HomeNav/HomeNav';
import GellerLogo from '../GellerLogo/GellerLogo';

const Hero = ({subtitle, btnText, title, titleClass, subtitleClass, imgClass}) => {
  const tClass = titleClass ? titleClass : 'hero-title-1';
  const subTClass = subtitleClass ? subtitleClass : 'hero-subtitle';
  const imClass = imgClass ? imgClass : 'hero-image';
  return (
    <div className="hero parallax-container">
      <div className='container p-0'>
        <HomeNav />
        <div className="hero-content">
          <GellerLogo className="hero-logo" />
          <div className="hero-text">
            <h2 className={subTClass}>{subtitle}</h2>
            <h2 className={tClass}>
              {title}
            </h2>
            { btnText && <a href="/our_products/1">
              <button className='hero-button'>{btnText}</button>
            </a> }
          </div>
        </div>
      </div>
      <div className={imClass + ' parallax-layer'}></div>
    </div>
  );
};

export default Hero;


// WEBPACK FOOTER //
// src/components/Hero/Hero.js